/**
 * Created by pyt on 1/18/17.
 */
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const SAVE_CAMPAIGNS = 'SAVE_CAMPAIGNS';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const UPDATE_CAMPAIGNS_LIST = 'UPDATE_CAMPAIGNS_LIST';
